module.exports = __webpack_public_path__ + "media/applicants/instacart-logo-for-jobsposting-85bc846d.png";